import React from 'react';

import { SearchPanel, ToolBar } from '_app/components';
import { useSearchFormController } from '_app/features/property-search/useSearchFormController';

const SearchForm = () => {
  const controller = useSearchFormController();

  return (
    <div className="flex flex-1 flex-col justify-center items-center font-primary relative overflow-hidden">
      <ToolBar
        visibleSearch={true}
        visibleList={false}
        publicId={controller.publicId}
        searchModeItem={controller.simpleSearch}
        onChangeSearchMode={controller.updateItem}
      />
      <div className="flex-1 w-full flex h-full flex-row relative">
        <div className="absolute inset-0">
          <SearchPanel
            publicId={controller.publicId}
            sections={controller.sections}
            loading={controller.loading}
            simpleSearch={controller.simpleSearch}
            onChangeItem={controller.updateItem}
            onCancel={controller.onCancel}
            onReset={controller.onReset}
            onApply={controller.onApply}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
